import React from 'react';

export default function ScoreDisplay({ score }) {
  const scoreTextStyle = {
    position: 'absolute',
    top: '40px',
    left: '40px',
    color: 'black',
    fontSize: '64px',
    fontFamily: "'CodinaCustom', sans-serif",
    fontWeight: '600',
    zIndex: 10,
    pointerEvents: 'none',
    userSelect: 'none', // Prevents text selection on all browsers
    WebkitUserSelect: 'none', // For Safari/iOS
    MozUserSelect: 'none', // For Firefox
    msUserSelect: 'none', // For IE/Edge
  };

  return (
    <div style={scoreTextStyle}>
      {score}
    </div>
  );
}